module.exports = __webpack_public_path__ + "static/21-1ed9b8de18b1135a8c9777326a9b59c3.jpg";